exports.network = 'RMC'

exports.epoch = 946684800

exports.transactionResults = {
  SUCCESS: 'tesSUCCESS'
}

exports.nativeCurrency = 'RMC'

exports.precision = 6



//////////////////
// WEBPACK FOOTER
// ./src/helpers/constants.js
// module id = 224
// module chunks = 0